const coreApiUrl = import.meta.env.VITE_MENUUS_CORE_API_URL;

export const V3 = coreApiUrl
  ? `${coreApiUrl.replace(/\/$/, "")}/api/v3`
  : "/api/v3";

/** true quando V3 ja e uma URL absoluta (core-api com host proprio ou mesmo host via env). */
export const V3_IS_ABSOLUTE = /^https?:\/\//.test(V3);

/**
 * @param {string} path - ex. "/user/auth" (com barra inicial)
 * @param {string} [baseUrl] - baseURL usada quando V3 e relativo
 */
export function v3Url(path, baseUrl = import.meta.env.VITE_MENUUS_API_URL) {
  return V3_IS_ABSOLUTE ? `${V3}${path}` : `${baseUrl}${V3}${path}`;
}
